<template>
  <div class="emp-modal show -overlay" @click="close($event)">
    <div class="content">
      <header class="modal-top-bar">
        <div></div>
        <a href="javascript:void(0)" class="btn-close" @click="$emit('close', true)"></a>
      </header>

      <div class="content-modal" :class="$attrs.data.type == 'ANTICIPATION' ? '-anticipation' : ''">
        <template v-if="$attrs.data.type == 'INFO'">
          <h3>{{ $attrs.data.title }}</h3>
          <p>{{ $attrs.data.text }}</p>
        </template>

        <template v-if="$attrs.data.type == 'BARCODE'">
          <p class="barscode aligncenter"><strong>Falha ao gerar PDF.</strong></p>
        </template>

        <template v-if="$attrs.data.type == 'BOLETO_SUCCESS'">
          <h4 class="-green">Sucesso!</h4>
          <p class="success-message">Enviamos o boleto em PDF para o seu e-mail de cadastro. Segue abaixo a linha digitável:</p>

          <div class="linha-digitavel-box">
            <p class="linha-digitavel">{{ formatLinhaDigitavel($attrs.data.linhaDigitavel) }}</p>
            <button class="btn btn-copy" @click="copyLinhaDigitavel" :class="{ 'copied': copySuccess }">
              {{ copySuccess ? 'Copiado!' : 'Copiar' }}
            </button>
          </div>
        </template>

        <template v-if="$attrs.data.type == 'ANTICIPATION'">
          <template v-if="$attrs.data.typeStatus == 'INFO'">
            <div class="-vals">
              <p><strong>TOTAL SEM O DESCONTO:</strong> {{ $attrs.data.info.VALOR_ANTIGO }}<br>&nbsp;</p>
              <p style="color: #ff0000; margin-bottom: 10px;"><strong>DESCONTO:</strong> {{ $attrs.data.info.VALOR_DESCONTO }}</p>
              <p><strong>VALOR À PAGAR:</strong> {{ $attrs.data.info.VALOR_TOTAL }}</p>
            </div>

            <a href="javascript:void(0)" class="btn btn-default" @click="$emit('antecipar', $attrs.data.info)">GERAR BOLETO DE ANTECIPAÇÃO</a>
          </template>

          <template v-if="$attrs.data.typeStatus == 'OK'">
            <h4 class="-green">{{ $attrs.data.text || 'Antecipação gerada com sucesso!' }}</h4>
          </template>

          <template v-if="$attrs.data.typeStatus == 'FAIL'">
            <h4 class="-red">{{ $attrs.data.text || 'Falha ao gerar antecipação. Tente mais tarde.' }}</h4>
          </template>
        </template>
      </div> <!-- /.content-modal -->
    </div> <!-- /.content -->
  </div> <!-- /.emp-modal -->
</template>

<script>
import Vue from 'vue'

export default {
  components: {
  },

  data () {
    const data = {
      urlFiles: Vue.prototype.urlFiles,
      copySuccess: false
    }

    return data
  }, // data()

  mounted () {
    // Caso seja modal de galeria
    if (this.$attrs.data.type === 'REGUA') {
      console.debug('É regua!!!!', this.$attrs)
    }

    document.addEventListener('keyup', this.escPress)
  }, // mounted()

  methods: {
    // #######################################################
    // ################## Comuns
    // #######################################################
    escPress (ev) {
      if (ev.keyCode === 27 || ev.which === 27) return this.close(false)
    }, // escPress()

    close (ev) {
      // Prevent closing by clicking overlay if modal type is BOLETO_SUCCESS
      if (this.$attrs.data.type === 'BOLETO_SUCCESS') {
        return
      }

      if (!ev || ev.target.classList.contains('-overlay')) {
        document.removeEventListener('keyup', this.escPress, false)

        this.$emit('close', true)
      }
    }, // close()

    toggleShare () {
      this.displayShare = !this.displayShare
    },

    isMobile () {
      return screen.width <= 1024
    }, // isMobile()

    formatLinhaDigitavel (linha) {
      if (!linha) return ''
      // Remove any existing spaces
      const cleanLinha = linha.replace(/\s/g, '')

      const formatted = [
        cleanLinha.substring(0, 5),
        '.',
        cleanLinha.substring(5, 10),
        ' ',
        cleanLinha.substring(10, 15),
        '.',
        cleanLinha.substring(15, 21),
        ' ',
        cleanLinha.substring(21, 26),
        '.',
        cleanLinha.substring(26, 32),
        ' ',
        cleanLinha.substring(32, 33),
        ' ',
        cleanLinha.substring(33)
      ]

      return formatted.join('')
    }, // formatLinhaDigitavel()

    async copyLinhaDigitavel () {
      try {
        const linhaDigitavel = this.$attrs.data.linhaDigitavel

        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(linhaDigitavel)
        } else {
          const textArea = document.createElement('textarea')
          textArea.value = linhaDigitavel
          textArea.style.position = 'fixed'
          textArea.style.left = '-999999px'
          textArea.style.top = '-999999px'
          document.body.appendChild(textArea)
          textArea.focus()
          textArea.select()
          document.execCommand('copy')
          textArea.remove()
        }

        this.copySuccess = true
        setTimeout(() => {
          this.copySuccess = false
        }, 2000)
      } catch (error) {
        console.error('Erro ao copiar linha digitável:', error)
      }
    }, // copyLinhaDigitavel()

    calculateValorAPagar () {
      const valorTotal = parseFloat(this.$attrs.data.info.VALOR_TOTAL_RAW) || 0
      const valorDesconto = parseFloat(this.$attrs.data.info.VALOR_DESCONTO_RAW) || 0
      return valorTotal - valorDesconto
    }, // calculateValorAPagar()

    formatCurrency (value) {
      const numValue = typeof value === 'number' ? value : parseFloat(value) || 0
      return numValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })
    } // formatCurrency()
  } // methods
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .modal-top-bar
    width: 100%
    display: flex
    justify-content: space-between
    align-items: center
    height: 55px
    background: map-get($colors, gray)
    border-radius: 15px 15px 0 0
    position: relative

    h2
      font-weight: 400
      font-size: 30px
      color: #fff
      padding-left: 10px

    .btn-close
      // position: absolute
      // top: 50%
      // right: 10px
      // transform: translateY(-50%)
      margin-right: 10px
      margin-top: 3px
      width: 20px
      height: 20px
      background-color: map-get($colors, primary)
      border-radius: 5px
      background-image: url(~/images/icons/modal-close.png)
      background-size: 10px auto
      background-repeat: no-repeat
      background-position: center

  @media (max-width: 1024px)
    .modal-top-bar
      border-radius: 7px 7px 0 0
      padding-top: 26px
      height: auto
      padding-bottom: 10px
      position: relative !important

      .btns-left.-highlights
        width: 100%
        display: flex
        justify-content: space-between

        .-btn
          margin-right: 10px

        .social
          left: initial
          right: 10px

        .counter
          display: none

      h3
        display: none

      .btn-close
        width: 30px
        height: 30px
        top: -17px
        right: 5px
        position: absolute

  .emp-modal
    position: fixed
    width: 100%
    height: 100%
    top: 0
    right: 0
    bottom: 0
    left: 0
    background: rgba(#000, 0.5)
    z-index: 100000
    display: flex
    align-items: center
    justify-content: center

    .content
      $sideSpaces: 10px
      $sizeSquare: 150px
      max-width: 640px
      width: 95vw
      border-radius: 15px
      box-shadow: 0 13px 21px rgba(1, 2, 1, .69)

      .content-modal
        background: #fff
        padding: 10px $sideSpaces 10px $sideSpaces
        position: relative
        overflow: hidden

        &.-anticipation
          text-align: center

        div.-vals
          display: flex
          align-items: center
          justify-content: space-between
          flex-direction: column
          flex-wrap: wrap
          margin-bottom: 20px

          p
            flex: 0 33%
            font-size: 16px
            color: #000

        h3
          text-align: center
          text-transform: uppercase
          margin-bottom: 15px
          font-size: 22px

        h4
          font-size: 18px
          color: map-get($colors, green)
          text-transform: uppercase
          margin-bottom: 20px

          &.-red
            text-align: center
            color: #b42c04
            margin-bottom: 0

          &.-green
            text-align: center
            color: map-get($colors, green)
            margin-bottom: 20px

        .barscode
          display: block
          text-transform: uppercase

          strong
            display: block
            margin-top: 10px
            font-weight: 600
            font-size: 20px

        .success-message
          text-align: center
          margin-bottom: 25px
          font-size: 16px
          color: #333

        .linha-digitavel-box
          background: #f5f5f5
          border: 2px solid #ddd
          border-radius: 8px
          padding: 20px
          text-align: center
          margin-bottom: 20px
          align-items: center
          display: flex
          justify-content: center
          flex-direction: column

          .linha-digitavel
            font-family: 'Courier New', monospace
            font-size: 16px
            font-weight: 600
            color: #333
            letter-spacing: 0
            margin-bottom: 15px
            word-break: break-all
            line-height: 1.4

        .btn-copy
          background: map-get($colors, blue)
          color: #fff
          border: none
          padding: 10px 20px
          border-radius: 5px
          font-size: 14px
          font-weight: 600
          cursor: pointer
          transition: all 0.3s ease
          text-transform: uppercase

          &:hover
            background: darken(map-get($colors, blue), 10)

          &.copied
            background: map-get($colors, green)
            &:hover
              background: map-get($colors, green)

        .btn-default
          font-size: 18px
          letter-spacing: 0px
          margin-top: 20px
          font-weight: 500
          padding: 6px 20px 6px
          position: relative

        .-swiper
        overflow: hidden

        figure
          overflow: hidden

          div
            background: map-get($colors, gray)

            img
              display: block
              // min-width: 80vw
              // width: 100%
              height: auto
              max-height: calc(100vh - 150px)
              // max-width: 85vw
              // max-height: 75vh
              // height: auto
              width: auto
              margin: 0 auto

      .caption
        background: #313131
        padding: 14px 30px 12px
        border-radius: 0px 0px 12px 12px
        text-align: center
        overflow: hidden
        line-height: 21px

        p
          display: block
          font-size: 19px
          color: #fff

  @media (max-width: 1024px)
    .emp-modal

      .content
        // width: 100%
        max-width: 98vw
        max-height 90vh

        .-swiper
          $sizeSquare: 100px
          $sideSpaces: 40px

          .btn
            width: $sizeSquare
            height: $sizeSquare
            border-radius: 10px

            &:before
              content: ''
              background-image: url(~/images/icons/arrow-left-blue.png)
              background-size: contain
              background-repeat: no-repeat
              width: 30px
              height: 47px
              position: absolute

            &.btn-prev
              left: calc(#{$sideSpaces} - 100px)

              &:before
                top: 5%
                left: 58%

            &.btn-next
              right: calc(#{$sideSpaces} - 100px)

              &:before
                top: 48%;
                left: 13%;

        .content-modal
          overflow-y: auto

          &.-plant
            max-height: calc(80vh - 75px)

            .tabs
              a
                width: 100%
                max-width: initial

            .info
              display: block

              .-swiper
                width: 100%

                figure div
                  p
                    width: 20px
                    height: 20px
                    font-size: 15px
                    line-height: 20px

              .list-items
                width: 100%
                display: flex
                flex-wrap: wrap

                li
                  width: 100%
                  flex: 0 calc(50% - 10px)
                  margin: 0 5px
                  font-size: 14px
                  padding: 9px 6px 9px

              .arrows-mobile
                display: block
                text-align: center

                a
                  display: inline-block
                  width: 40px
                  height: 80px
                  margin: 0 7px
                  background-image: url(~/img/icons/btn-right-triangle-blue.png)
                  background-repeat: no-repeat
                  background-position: center
                  background-size: contain

                  &.btn-prev
                    transform: rotate(180deg)

  @media (max-width: 767px)
    .emp-modal
      .content-modal
        text-align: center
</style>
